/* ══════════════════════════════════════════════════════════
   K9 Vitality — Below-Fold PDP JS
   IntersectionObserver animations, video modal, carousels
   ══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── 1. Scroll-triggered reveal animations ── */
  function initRevealObserver() {
    var els = document.querySelectorAll('.kv-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      /* Fallback: show everything immediately */
      els.forEach(function (el) { el.classList.add('kv-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kv-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── 2. Carousel — pure native scroll, no JS override ── */
  /* Native CSS handles smooth scroll via:
     scroll-snap-type: x mandatory + scroll-behavior: smooth +
     -webkit-overflow-scrolling: touch + touch-action: pan-x
     This matches the signs carousel which also relies on native scroll on mobile.
     JS drag only added for desktop mouse users. */
  function initCarousels() {
    document.querySelectorAll('.kv-hscroll').forEach(function (el) {
      if (el._kvScrollInit) return;
      el._kvScrollInit = true;

      /* Desktop-only: mouse drag (not touch — native touch is already smooth) */
      var isDragging = false, startX, startLeft;

      el.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX = e.pageX;
        startLeft = el.scrollLeft;
        el.style.cursor = 'grabbing';
        el.style.scrollBehavior = 'auto'; /* disable smooth during drag */
        e.preventDefault();
      });

      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        el.style.cursor = '';
        el.style.scrollBehavior = ''; /* re-enable smooth */
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        el.scrollLeft = startLeft + (startX - e.pageX);
      });
    });
  }

  /* ── 3. FAQ accordion: one-at-a-time ── */
  function initFaqAccordion() {
    var wrap = document.querySelector('.kv-faq-wrap');
    if (!wrap) return;

    var items = wrap.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  }

  /* ── 4. Video modal ── */
  function initVideoModal() {
    var modal = document.querySelector('.kv-video-modal');
    if (!modal) return;

    var container = modal.querySelector('.kv-video-container');
    var backdrop = modal.querySelector('.kv-video-backdrop');
    var closeBtn = modal.querySelector('.kv-video-close');

    function open(videoUrl) {
      /* Clear previous content safely */
      while (container.firstChild) container.removeChild(container.firstChild);

      /* Close button */
      var closeBtnNew = document.createElement('button');
      closeBtnNew.className = 'kv-video-close';
      closeBtnNew.setAttribute('aria-label', 'Close video');
      closeBtnNew.textContent = '\u00D7';
      closeBtnNew.addEventListener('click', close);
      container.appendChild(closeBtnNew);

      /* Determine embed type and build element via DOM API */
      var mediaEl;
      if (videoUrl.indexOf('youtube.com') > -1 || videoUrl.indexOf('youtu.be') > -1) {
        var ytId = videoUrl.match(/(?:v=|youtu\.be\/)([^&?]+)/);
        mediaEl = document.createElement('iframe');
        mediaEl.src = 'https://www.youtube.com/embed/' + (ytId ? ytId[1] : '') + '?autoplay=1&rel=0';
        mediaEl.allow = 'autoplay; encrypted-media';
        mediaEl.allowFullscreen = true;
      } else if (videoUrl.indexOf('vimeo.com') > -1) {
        var vmId = videoUrl.match(/vimeo\.com\/(\d+)/);
        mediaEl = document.createElement('iframe');
        mediaEl.src = 'https://player.vimeo.com/video/' + (vmId ? vmId[1] : '') + '?autoplay=1';
        mediaEl.allow = 'autoplay';
        mediaEl.allowFullscreen = true;
      } else {
        mediaEl = document.createElement('video');
        mediaEl.src = videoUrl;
        mediaEl.controls = true;
        mediaEl.autoplay = true;
        mediaEl.playsInline = true;
      }
      container.appendChild(mediaEl);

      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeBtnNew.focus();
    }

    function close() {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      while (container.firstChild) container.removeChild(container.firstChild);
      document.body.style.overflow = '';
    }

    /* Focus trap — keep Tab within modal when open */
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !modal.classList.contains('active')) return;
      var focusable = modal.querySelectorAll('button, iframe, video, [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (backdrop) backdrop.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) close();
    });

    /* Delegate click from any video trigger */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-kv-video]');
      if (trigger) {
        e.preventDefault();
        open(trigger.getAttribute('data-kv-video'));
      }
    });
  }

  /* ── 5. Smooth scroll for CTA anchors ── */
  function initSmoothScroll() {
    document.querySelectorAll('.kv-below-fold a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var offset = 80; /* account for sticky header */
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* ── 6. Carousel keyboard navigation ── */
  function initCarouselKeyboard() {
    document.querySelectorAll('.kv-hscroll').forEach(function (el) {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'region');
      el.setAttribute('aria-label', 'Scrollable cards');
      el.addEventListener('keydown', function (e) {
        var step = 240;
        if (e.key === 'ArrowRight') { el.scrollBy({ left: step, behavior: 'smooth' }); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { el.scrollBy({ left: -step, behavior: 'smooth' }); e.preventDefault(); }
      });
    });
  }

  /* ── 7. Count-up animation for stat numbers ── */
  function initCountUp() {
    var els = document.querySelectorAll('.kv-countup');
    if (!els.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);

        var target = parseInt(el.getAttribute('data-target'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        if (isNaN(target)) return;

        var duration = 1200; /* ms */
        var start = performance.now();

        function step(now) {
          var progress = Math.min((now - start) / duration, 1);
          /* Ease-out cubic */
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(eased * target);
          el.textContent = current + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── 8. Lazy-load third-party images (Judge.me, etc.) ── */
  function initThirdPartyLazyLoad() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var imgs = node.querySelectorAll ? node.querySelectorAll('img:not([loading])') : [];
          imgs.forEach(function (img) {
            var rect = img.getBoundingClientRect();
            if (rect.top > 900) img.loading = 'lazy';
          });
          if (node.tagName === 'IMG' && !node.loading) {
            var r = node.getBoundingClientRect();
            if (r.top > 900) node.loading = 'lazy';
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Stop observing after 15 seconds (all widgets should be loaded by then)
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  /* ── Init ── */
  function init() {
    initRevealObserver();
    initCarousels();
    initFaqAccordion();
    initVideoModal();
    initSmoothScroll();
    initCarouselKeyboard();
    initCountUp();
    initThirdPartyLazyLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-init */
  document.addEventListener('shopify:section:load', init);
})();
